interface Code_ {
  [key: number]: string;
}

const code: Code_ = {
  200: "Connexion réussite",
  // User Success Codes
  201: "L'utilisateur a été enregistré avec succès !",
  202: "L'utilisateur a été modifié avec succès !",
  203: "L'utilisateur a été supprimé avec succès !",
  204: "Les utilisateurs ont été supprimés avec succès !",
  // Device Success Codes
  211: "L'appareil a été enregistré avec succès !",
  212: "L'appareil a été modifié avec succès !",
  213: "L'appareil a été supprimé avec succès !",
  214: "Les appareils ont été ajoutés avec succès !",

  221: "L'enquête a été enregistrée avec succès !",
  222: "L'enquête a été modifiée avec succès !",

  231: "Les postes ont bien été ajoutés",
  232: "Le poste a bien été supprimé",
  233: "Le poste a bien été modifié",
  234: "Le poste a bien été créé",
  // User Error Codes
  400: "Nom d'utilisateur et/ou mot de passe inconnu",
  401: "Cette adresse email est déjà utilisée",
  402: "L'email n'a pas put être envoyé",
  403: "Vous n'avez pas les droits pour effectuer cette action",
  404: "L'utilisateur n'a pas pu être trouvé",
  405: "Un ou plusieurs utilisateur n'ont pas pu être trouvés ou supprimés",
  406: "L'utilisateur n'a pas pu être créé",
  // Device Errors Codes
  410: "L'appareil n'a pas pu être créé",
  411: "Ce nom d'appareil est déjà utilisé",
  412: "Le csv n'a pas pu être importé un ou plusieurs noms de matériaux sont déjà présents",

  421: "L'enquête n'a pas pu être créée",
  422: "L'enquête n'a pas pu être modifiée",
  423: "L'enquête n'a pas pu être supprimée",
  424: "L'enquête n'a pas pu être trouvée",

  431: "Les postes n'ont pas pu être ajoutés",
  432: "Le poste n'a pas pu être supprimé",
  433: "Le poste n'a pas pu être modifié",
  434: "Le poste n'a pas pu être créé",

  500: "Il y a une erreur avec le serveur"
};

export default code;
